import React, { useState, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import FormGroup from '../../FormGroup';
import ButtonsList from '../../ButtonsList';
import { I18nContext } from 'utils/I18n/context';

const ConversionStatuses = ({ edit, statuses, onAction }) => {
    const { t } = useContext(I18nContext);
    const [state, setState] = useState({
        edit: edit,
        statuses: statuses || []
    });

    const staticNames = t?.postbackPage?.creatingEditing || { 
        conversionStatusTitle: 'Conversion Status', 
        all: 'All', 
        new: 'New', 
        confirmed: 'Confirmed', 
        rejected: 'Rejected', 
        form: { status: 'Status' } 
    };

    const onChange = useCallback((value) => {
        let statuses = state.statuses;
        let isAllActive = ['new', 'confirmed', 'rejected'].every(item => statuses.includes(item));

        if (value === 'all') {
            statuses = isAllActive ? [] : ['new', 'confirmed', 'rejected'];
        } else if (value && isAllActive) {
            statuses = [value];
        } else {
            const index = statuses.indexOf(value);
            index === -1 ? statuses.push(value) : statuses.splice(index, 1);
        }

        setState(prev => ({
            ...prev,
            statuses
        }), () => {
            onAction(state);
        });
    }, [state.statuses, state, onAction]);

    const isChecked = useCallback((value) => {
        let checked = false;

        if (value && state.statuses.indexOf(value) !== -1 || !value && !state.statuses.length) {
            checked = true;
        }

        return checked;
    }, [state.statuses]);

    return (
        <FormGroup
            fieldClass="input-wrapper"
        >
            <h3 className="bold subtitle">{staticNames.conversionStatusTitle}</h3>
            <ButtonsList
                fields={[{
                    key: 'status',
                    list: [
                        {value: 'all', title: staticNames.all},
                        {value: 'new', title: staticNames.new},
                        {value: 'confirmed', title: staticNames.confirmed},
                        {value: 'rejected', title: staticNames.rejected}
                    ],
                    label: staticNames.form.status
                }]}
                data={{key: 'status'}}
                currentValue={state.statuses}
                multiOptions={true}
                onChange={onChange}
            />
        </FormGroup>
    );
};

ConversionStatuses.propTypes = {
    edit: PropTypes.bool,
    statuses: PropTypes.array,
    onAction: PropTypes.func
};

ConversionStatuses.defaultProps = {
    edit: false,
    statuses: [],
    onAction: () => {}
};

export default ConversionStatuses;
